import { createAPI } from '../../composable/useAPI';

export const useProcessAPI = () =>{
  const api = createAPI();

  const request = {
    process:{
      get: async (params) => {
        return await api.get('/api/v2/process', { params })
          .then((res) => { return res.data.data; })
          .catch (err => { console.error(err); return false })
      },
      post: async (data) => {
        return await api.post('/api/v2/process', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return err; })
      },
      put: async (data) => {
          return await api.put('/api/v2/process', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return err })
      },
      delete: async(params) => {
        const queryString = params.map((seq) => `processSeq=${ seq }`).join('&');
          return await api.delete(`/api/v2/process?${ queryString }`)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      selector: async (params) => {
        return await api.get('/api/v2/process/apiSelector', { params })
          .then((res) => { return res.data.data; })
          .catch (err => { console.error(err); return false })
      },
      download: async (params) => {
        try {
          const res = await api.get('/api/v2/process/download', {
            params,
            responseType: 'blob',
          });
          const contentType = res.headers['content-type'] ||
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          let filename = '공정_목록.xlsx';
          const dispo = res.headers['content-disposition'];
          if (dispo) {
            const m = /filename\*=UTF-8''([^;]+)|filename="([^"]+)"/i.exec(dispo);
            const raw = m?.[1] || m?.[2];
            if (raw) {
              try { filename = decodeURIComponent(raw); } catch { filename = raw; }
            }
          }
          const blob = new Blob([res.data], { type: contentType });
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = filename;
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        } catch (err) {
          console.error('다운로드 실패:', err);
          throw err;
        }
      },
      import: async (formData) => {
        try {
          const response = await api.post('/api/v2/process/import', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            withCredentials: true,
          });
          return response.data;
        } catch (error) {
          console.error('엑셀 업로드 실패:', error);
          return false;
        }
      }
    },

    processStep:{
      get: async (params) => {
        return await api.get('/api/v2/process_step', { params })
          .then((res) => { return res.data.data })
          .catch (err => { console.error(err); return false })
      },
      post: async (data) => {
        return await api.post('/api/v2/process_step', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      put: async (data) => {
          return await api.put('/api/v2/process_step', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      delete: async(params) => {
        const queryString = params.map((seq) => `processStepSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/process_step?${queryString}`)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      }
    },

    processBOM:{
      get: async (params) => {
        return await api.get('/api/v2/process_bom', { params })
          .then((res) => { return res.data.data })
          .catch (err => { console.error(err); return false })
      },
      post: async (data) => {
        return await api.post('/api/v2/process_bom', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      put: async (data) => {
          return await api.put('/api/v2/process_bom', data)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      },
      delete: async(params) => {
        const queryString = params.map((seq) => `processBOMSeq=${seq}`).join('&');
          return await api.delete(`/api/v2/process_bom?${queryString}`)
          .then((res) => { return res.data.status === 200 })
          .catch (err => { console.error(err); return false })
      }
    }
  };

  return {
    ...request
  };
}
